
import { Vue, Component } from 'vue-property-decorator'
import DashboardSale from '../../components/Dashboards/DashboardSale.vue'
  @Component({
    components: { DashboardSale }
  })
export default class baohe extends Vue {
  mounted() {}
}
